import { useEffect, useState } from "react";
import { ArrowRight, Clock3 } from "lucide-react";
import { PageHeader, StatusPill } from "../components/Primitives";
import { Modal } from "../components/Modal";
import { api, errorText, formatTime12 } from "../lib/api";

export default function Shifts() {
  const [shifts, setShifts] = useState([]);
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({ name: "", start_time: "06:00", end_time: "10:00", capacity: 50 });
  const [error, setError] = useState("");

  const load = async () => {
    try {
      const res = await api.get("/shifts");
      setShifts(res.data.data);
    } catch (err) {
      setError(errorText(err));
    }
  };

  useEffect(() => {
    load();
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    try {
      await api.post("/shifts", { ...form, capacity: Number(form.capacity) });
      setShow(false);
      setForm({ name: "", start_time: "06:00", end_time: "10:00", capacity: 50 });
      load();
    } catch (err) {
      setError(errorText(err));
    }
  };

  return (
    <div className="page-enter">
      <PageHeader
        eyebrow="TIME WINDOWS"
        title="Shifts"
        description="Keep your library's opening rhythm visible to the whole team."
        action={
          <button className="button button-primary" onClick={() => setShow(true)} data-testid="add-shift-button">
            <Clock3 size={17} /> Add shift
          </button>
        }
      />
      {error ? <div className="error-message">{error}</div> : null}
      <div className="shift-grid">
        {shifts.map((shift) => (
          <article className="content-card shift-card" key={shift.id} data-testid={`shift-card-${shift.id}`}>
            <div className="shift-icon"><Clock3 size={20} /></div>
            <h2>{shift.name}</h2>
            <p>{formatTime12(shift.start_time)} — {formatTime12(shift.end_time)}</p>
            <div className="shift-capacity"><span>Capacity</span><strong>{shift.capacity} seats</strong></div>
            <div className="shift-capacity"><span>Enrolled</span><strong>{shift.student_count}</strong></div>
            <StatusPill status={shift.status} />
          </article>
        ))}
      </div>
      {show ? (
        <Modal title="Add shift" eyebrow="NEW WINDOW" close={() => setShow(false)} testId="add-shift-modal">
          <form className="modal-form" onSubmit={submit}>
            <label>Name<input required value={form.name} onChange={(event) => setForm({ ...form, name: event.target.value })} data-testid="shift-name-input" /></label>
            <div className="form-split">
              <label>Starts<input type="time" value={form.start_time} onChange={(event) => setForm({ ...form, start_time: event.target.value })} data-testid="shift-start-input" /></label>
              <label>Ends<input type="time" value={form.end_time} onChange={(event) => setForm({ ...form, end_time: event.target.value })} data-testid="shift-end-input" /></label>
            </div>
            <label>Capacity<input type="number" min="1" value={form.capacity} onChange={(event) => setForm({ ...form, capacity: event.target.value })} data-testid="shift-capacity-input" /></label>
            <div className="modal-actions">
              <button type="button" className="button button-outline" onClick={() => setShow(false)}>Cancel</button>
              <button className="button button-primary" type="submit" data-testid="save-shift-button">
                Create shift <ArrowRight size={16} />
              </button>
            </div>
          </form>
        </Modal>
      ) : null}
    </div>
  );
}
